export default __webpack_public_path__ + "static/media/schedule-icon.6702aeda.svg";